import apiService from './apiService';
import { API_ENDPOINTS } from '../config/api'; // HOZZÁADVA

class NotificationService {
  // Felhasználó értesítései
  async getUserNotifications(page = 1, limit = 10, params = {}) { // MÓDOSÍTOTT PARAMÉTEREK
    try {
      const queryParams = new URLSearchParams({ page, limit, ...params }).toString();
      const response = await apiService.get(`${API_ENDPOINTS.NOTIFICATIONS.BASE}?${queryParams}`); // API_ENDPOINTS használata
      return response;
    } catch (error) {
      console.error('Értesítések lekérése hiba:', error);
      throw error;
    }
  }

  // Olvasatlan értesítések száma
  async getUnreadCount() {
    try {
      const response = await apiService.get(API_ENDPOINTS.NOTIFICATIONS.UNREAD_COUNT); // API_ENDPOINTS használata
      return response;
    } catch (error) {
      console.error('Olvasatlan értesítések száma hiba:', error);
      throw error;
    }
  }

  // Értesítés olvasottnak jelölése
  async markAsRead(notificationId) {
    try {
      const response = await apiService.put(API_ENDPOINTS.NOTIFICATIONS.MARK_AS_READ(notificationId)); // API_ENDPOINTS használata
      return response;
    } catch (error) {
      console.error('Értesítés olvasottnak jelölése hiba:', error);
      throw error;
    }
  }

  // ÚJ: Értesítés olvasatlannak jelölése
  async markAsUnread(notificationId) {
    try {
      const response = await apiService.put(API_ENDPOINTS.NOTIFICATIONS.MARK_AS_UNREAD(notificationId));
      return response;
    } catch (error) {
      console.error(`Error marking notification ${notificationId} as unread:`, error);
      throw error;
    }
  }

  // Összes értesítés olvasottnak jelölése
  async markAllAsRead() {
    try {
      const response = await apiService.put(API_ENDPOINTS.NOTIFICATIONS.MARK_ALL_AS_READ); // API_ENDPOINTS használata
      return response;
    } catch (error) {
      console.error('Összes értesítés olvasottnak jelölése hiba:', error);
      throw error;
    }
  }

  // Értesítés törlése
  async deleteNotification(notificationId) {
    try {
      const response = await apiService.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE(notificationId)); // API_ENDPOINTS használata
      return response;
    } catch (error) {
      console.error('Értesítés törlése hiba:', error);
      throw error;
    }
  }

  // ÚJ: Több értesítés olvasottnak jelölése
  async markMultipleAsRead(notificationIds) {
    try {
      const response = await apiService.put(API_ENDPOINTS.NOTIFICATIONS.MARK_MULTIPLE_AS_READ, { notificationIds });
      return response;
    } catch (error) {
      console.error('Error marking multiple notifications as read:', error);
      throw error;
    }
  }

  // ÚJ: Több értesítés olvasatlannak jelölése
  async markMultipleAsUnread(notificationIds) {
    try {
      const response = await apiService.put(API_ENDPOINTS.NOTIFICATIONS.MARK_MULTIPLE_AS_UNREAD, { notificationIds });
      return response;
    } catch (error) {
      console.error('Error marking multiple notifications as unread:', error);
      throw error;
    }
  }

  // ÚJ: Több értesítés törlése
  async deleteMultiple(notificationIds) {
    try {
      const response = await apiService.delete(API_ENDPOINTS.NOTIFICATIONS.DELETE_MULTIPLE, { data: { notificationIds } }); // DELETE kérés body-val
      return response;
    } catch (error) {
      console.error('Error deleting multiple notifications:', error);
      throw error;
    }
  }

  // Valós idejű olvasatlan számláló frissítése (MEGTARTVA)
  async pollUnreadCount(callback, interval = 30000) {
    const poll = async () => {
      try {
        const response = await this.getUnreadCount();
        callback(response.unreadCount);
      } catch (error) {
        console.error('Olvasatlan számláló polling hiba:', error);
      }
    };

    // Azonnal futtatjuk egyszer
    await poll();
    
    // Majd beállítjuk az intervallumot
    return setInterval(poll, interval);
  }
}

export default new NotificationService();